import { ChangeDetectionStrategy, Component, EventEmitter, Output } from '@angular/core';

interface LegendItem {
  icon: string;
  iconType: 'material' | 'tabler';
  title: string;
  description: string;
  tone:
    | 'state-action'
    | 'state-info'
    | 'guide-assigned'
    | 'guide-empty'
    | 'success'
    | 'warning'
    | 'danger'
    | 'empty';
}

interface LegendSection {
  title: string;
  description: string;
  items: LegendItem[];
}

@Component({
  selector: 'app-file-programming-legend',
  templateUrl: './file-programming-legend.component.html',
  styleUrls: ['./file-programming-legend.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FileProgrammingLegendComponent {
  @Output() openFileStates = new EventEmitter<void>();

  isExpanded = false;

  readonly sections: LegendSection[] = [
    {
      title: 'Estados',
      description: 'El color del estado indica su momento en el flujo.',
      items: [
        {
          icon: 'pencil',
          iconType: 'tabler',
          title: 'Cambio manual',
          description: 'El lápiz indica que Operations puede avanzar el estado.',
          tone: 'state-action'
        },
        {
          icon: 'info-circle',
          iconType: 'tabler',
          title: 'Solo información',
          description: 'El estado no se cambia manualmente desde Operations.',
          tone: 'state-info'
        }
      ]
    },
    {
      title: 'Guía',
      description: 'Muestra si el file tiene guía principal.',
      items: [
        {
          icon: 'user',
          iconType: 'tabler',
          title: 'Guía asignado',
          description: 'Hay guía principal registrado para el file.',
          tone: 'guide-assigned'
        },
        {
          icon: 'user',
          iconType: 'tabler',
          title: 'Sin guía',
          description: 'Todavía no hay guía principal asignado.',
          tone: 'guide-empty'
        }
      ]
    },
    {
      title: 'Asignaciones',
      description: 'Muestra si el file ya tiene recursos críticos asignados.',
      items: [
        {
          icon: 'users',
          iconType: 'tabler',
          title: 'Pasajeros asignados',
          description: 'Icono verde cuando los PAX están asignados.',
          tone: 'success'
        },
        {
          icon: 'users',
          iconType: 'tabler',
          title: 'Pasajeros pendientes',
          description: 'Icono ámbar cuando falta asignar pasajeros.',
          tone: 'warning'
        },
        {
          icon: 'user-star',
          iconType: 'tabler',
          title: 'TC registrados',
          description: 'Icono verde cuando hay tour conductors registrados.',
          tone: 'success'
        },
        {
          icon: 'user-star',
          iconType: 'tabler',
          title: 'Sin TC',
          description: 'Icono ámbar cuando no hay tour conductors registrados.',
          tone: 'warning'
        },
        {
          icon: 'plane',
          iconType: 'tabler',
          title: 'Vuelos asignados',
          description: 'Icono verde cuando los vuelos están completos.',
          tone: 'success'
        },
        {
          icon: 'plane',
          iconType: 'tabler',
          title: 'Vuelos pendientes',
          description: 'Icono ámbar cuando faltan vuelos o están parciales.',
          tone: 'warning'
        }
      ]
    },
    {
      title: 'Revisiones',
      description: 'Ayuda a priorizar files con pendientes operativos.',
      items: [
        {
          icon: 'message-report',
          iconType: 'tabler',
          title: 'Programación sin pendientes',
          description: 'No hay incidentes pre-operativos pendientes.',
          tone: 'success'
        },
        {
          icon: 'book',
          iconType: 'tabler',
          title: 'Biblia sin pendientes',
          description: 'No hay revisiones AC pendientes.',
          tone: 'success'
        },
        {
          icon: 'message-report',
          iconType: 'tabler',
          title: 'Programación pendiente',
          description: 'Icono rojo con número cuando hay incidentes por resolver.',
          tone: 'danger'
        },
        {
          icon: 'book',
          iconType: 'tabler',
          title: 'Biblia pendiente',
          description: 'Icono rojo con número cuando hay revisiones AC pendientes.',
          tone: 'danger'
        },
        {
          icon: 'message-report',
          iconType: 'tabler',
          title: 'Programación sin revisión',
          description: 'Icono gris cuando no hay revisión de Programación iniciada.',
          tone: 'empty'
        },
        {
          icon: 'book',
          iconType: 'tabler',
          title: 'Biblia sin revisión',
          description: 'Icono gris cuando no hay revisión de Biblia iniciada.',
          tone: 'empty'
        }
      ]
    }
  ];

  toggleExpanded(): void {
    this.isExpanded = !this.isExpanded;
  }
}
